// extracted by css-extract-rspack-plugin
export default {"input":"euQYF2"};